import { render, staticRenderFns } from "./payment-link.vue?vue&type=template&id=dcbbd74e&scoped=true"
import script from "./payment-link.vue?vue&type=script&lang=js"
export * from "./payment-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbbd74e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcbbd74e')) {
      api.createRecord('dcbbd74e', component.options)
    } else {
      api.reload('dcbbd74e', component.options)
    }
    module.hot.accept("./payment-link.vue?vue&type=template&id=dcbbd74e&scoped=true", function () {
      api.rerender('dcbbd74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/online-transaction/payment-link.vue"
export default component.exports